import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import LogoEatorder from "../assets/images/eatorder-logo.png";
import { setScroll } from "../shared/slice/scroll/ScrollSlice";
import StoreBySpeciality from "./Home/StoreScreen/StoreBySpeciality";

import "@fortawesome/fontawesome-free/css/all.min.css";
import {
  MDBCol,
  MDBContainer,
  MDBFooter,
  MDBIcon,
  MDBRow,
} from "mdb-react-ui-kit";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../assets/images/eatorder-logo-white.png";
import ModalEmailSend from "../components/Modals/ModalEmailSend";
import ModalLogin from "../components/Modals/ModalLogin";
import ModalPrincipal from "../components/Modals/ModalPrincipal";
import ModalSignup from "../components/Modals/ModalSignup";
import SideNavBarSecond from "../components/Navbar/SideNavBarSecond";
import NotificationSecond from "../components/Notification/notificationSecond";
import TermsPopup from "../components/TermsOfService/TermsPopup";
import { ClientURI, store } from "../shared";
import { setmodalCheckout } from "../shared/slice/auth/AuthSlice";
import {
  setModalPrincipal,
  setModalSignup,
} from "../shared/slice/ModalLogin/ModalLoginSlice";
import { setPromos } from "../shared/slice/promos/PromosSlice";
import {
  setEditOrder,
  setMenu,
  setMode,
  setModeSelectedId,
  setOpenModal,
  setRestaurantSelected,
  setStores,
} from "../shared/slice/restaurant/RestaurantSlice";
import { setRootLoading } from "../shared/slice/rootSlice";
import { useSocket } from "../utils/socketContext";


const FirstPage = () => {
  const { socket, connected, joinStoreRoom} = useSocket();
  const loggedInGuest = useSelector(
    (state) => state.authentification.loggedInGuest
  );
  const loggedInUser = useSelector(
    (state) => state.authentification.loggedInUser
  );
  const isLoggedIn = useSelector((state) => state.authentification.isLoggedIn);
  const dispatch = useDispatch();
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const { t } = useTranslation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [userCountry, setUserCountry] = useState(null);
  const [onCountryDetected, setOnCountryDetected] = useState();
  // On récupère la liste des stores pour mise à jour socket
  const stores = useSelector((state) => state.restaurant.stores);
  const restaurantSelected = useSelector((state) => state.restaurant.restaurantSelected);

  useEffect(() => {
  if (restaurantSelected?._id && socket && connected) {
    joinStoreRoom(restaurantSelected._id);
  }
}, [restaurantSelected?._id, socket, connected]);
  // Utilisation de useEffect pour initialiser le scroll
  useEffect(() => {
    store.dispatch(setRootLoading(false));
    store.dispatch(setPromos({ promos: [] }));
    store.dispatch(setmodalCheckout({ modalCheckout: false }));
    dispatch(setMode({}));
    store.dispatch(setScroll({ scroll: 0 }));
    store.dispatch(setModeSelectedId({ modeSelectedId: "" }));
    store.dispatch(setRestaurantSelected({}));
    store.dispatch(setMenu({}));
  }, []);

  useEffect(() => {
    store.dispatch(
      setOpenModal({
        product: undefined,
        open: false,
      })
    );
    store.dispatch(
      setEditOrder({
        open: false,
        objectOptions: [],
        checkedIndices: [],
        checkedOptions: [],
        counter: {},
        orderQuantity: 0,
        note: undefined,
        size: "",
      })
    );
  }, []);
  const SignIn = () => {
    store.dispatch(setModalPrincipal({ modalPrincipal: true }));
  };
  const SignUp = () => {
    store.dispatch(setModalSignup({ modalSignup: true }));
  };
  useEffect(() => {
    const accepted = localStorage.getItem("termsAccepted") === "true";
    if (accepted) {
      setShowTermsPopup(false);
    } else {
      setShowTermsPopup(true);
    }
  }, []);
  const getLocationByIP = async () => {
    try {
      const response = await fetch(`${ClientURI}/geolocation`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data) {
        const { latitude, longitude, city, country, country_code } = data;

        if (onCountryDetected) {
          onCountryDetected(country_code.toLowerCase());
        }

        if (latitude && longitude) {
          return country_code.toLowerCase(); // Just return country code if that's what you need
        }
      }
    } catch (error) {
      console.error("IP geolocation failed:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchAndFilterStores = async () => {
      const country = await getLocationByIP(); // "france", "tunisia", etc.
      if (!country) return;

      if (country === "tunisia") {
        console.log("GPS requis en Tunisie");
        // pas de filtre automatique, attendre le GPS
        return;
      }

      dispatch(setStores());
    };

    fetchAndFilterStores();
  }, []);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        // 1. Détection du pays par IP d'abord
        const ipResponse = await fetch(`${ClientURI}/geolocation`);
        if (ipResponse.ok) {
          const ipData = await ipResponse.json();
          const countryCode = ipData.country_code?.toLowerCase();
          setUserCountry(countryCode);

          // 2. Récupération de la position GPS si nécessaire (Tunisie)
          let coords = null;
          if (countryCode === "tn") {
            try {
              const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                  enableHighAccuracy: true,
                  timeout: 10000,
                });
              });
              coords = `${position.coords.latitude},${position.coords.longitude}`;
            } catch (gpsError) {
              console.error("GPS error:", gpsError);
              // On continue sans coords pour la Tunisie
            }
          }

          // 3. Appel API pour les stores
          const queryParams = new URLSearchParams({
            userCountry: countryCode,
            ...(coords && { coords }),
          });

          const storesResponse = await fetch(
            `${ClientURI}/storesbyposition?${queryParams}`
          );
          if (storesResponse.ok) {
            const storesData = await storesResponse.json();
            dispatch(setStores(storesData));
          }
        }
      } catch (error) {
        console.error("Error in store fetching:", error);
        // Fallback: charger tous les stores
        const fallbackResponse = await fetch(`${ClientURI}/stores`);
        if (fallbackResponse.ok) {
          const fallbackData = await fallbackResponse.json();
          dispatch(setStores(fallbackData));
        }
      }
    };

    fetchStores();
  }, [dispatch]);

  return (
    <div>
      <Container>
        <LogoContainer>
          <LogoImage03 src={LogoEatorder} alt="Eatorder Logo" />
        </LogoContainer>
        {!isLoggedIn && (
          <div>
            <StyledAnchor onClick={() => SignIn()}>{t("Sign In")}</StyledAnchor>
            <StyledAnchor2 onClick={() => SignUp()}>
              {t("Sign Up")}
            </StyledAnchor2>
          </div>
        )}
        {isLoggedIn && (
          <div>
            <NotificationSecond
              style={{ backgroundColor: "green!important" }}
            />
            {unreadCount > 0 && (
              <CardBadge>
                <div>{unreadCount}</div>
              </CardBadge>
            )}

            <SideNavBarSecond />
          </div>
        )}
      </Container>
      {isLoggedIn &&
        ((loggedInUser && !loggedInUser.termsAccepted) ||
          (loggedInGuest && !loggedInGuest.termsAccepted)) && <TermsPopup />}

      <div>
        <ModalLogin />
        <ModalSignup />
        <ModalPrincipal />
        <ModalEmailSend />
      </div>
      <StoreBySpeciality />

      <MDBFooter
        style={{ fontSize: "1rem" }}
        bgColor="dark"
        className="text-center text-lg-start text-light"
      >
        <FooterSection className="d-flex flex-column flex-lg-row justify-content-between align-items-center p-4 border-bottom border-light">
          <SocialIcons>
            <span>{t("Get connected with us on social networks")}</span>
            <IconsContainer>
              <a
                href="#"
                className="me-3 text-reset text-light"
                aria-label="Facebook"
              >
                <MDBIcon fab icon="facebook-f" />
              </a>
              <a
                href="#"
                className="me-3 text-reset text-light"
                aria-label="Twitter"
              >
                <MDBIcon fab icon="twitter" />
              </a>
              <a
                href="#"
                className="me-3 text-reset text-light"
                aria-label="Google"
              >
                <MDBIcon fab icon="google" />
              </a>
              <a
                href="#"
                className="text-reset text-light"
                aria-label="Instagram"
              >
                <MDBIcon fab icon="instagram" />
              </a>
            </IconsContainer>
          </SocialIcons>
          <LinkContainer>
            <AnimatedLink href="/privacy-policy">
              {t("Privacy Policy")}
            </AnimatedLink>
            <AnimatedLink href="/terms-of-service">
              {t("Terms of Service")}
            </AnimatedLink>
          </LinkContainer>
        </FooterSection>
        <section className="">
          <MDBContainer className="text-center text-md-start mt-5">
            <MDBRow className="mt-3">
              <MDBCol
                md="3"
                lg="4"
                xl="3"
                className="mx-auto mb-4"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <h6 className="text-uppercase fw-bold mb-4">
                  <LogoImageFooter src={Logo} alt="Eatorder Logo" />
                </h6>
                <DescriptionText>
                  {t(
                    "Craving something delicious? Order your favorite meals from our platform and enjoy fast, easy, and reliable food delivery. Discover a wide variety of cuisines, exclusive deals, and hassle-free ordering. Satisfaction guaranteed with every bite."
                  )}
                </DescriptionText>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
      </MDBFooter>
    </div>
  );
};
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; /* Adjust spacing between logos */
`;
const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 3rem;
  background: rgba(255, 255, 255, 0.1);
  color: #f8f9fa;
  font-weight: 700;
  font-size: 1.1rem;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px -6px 20px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(15px);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px -8px 30px rgba(0, 0, 0, 0.5);
  }

  &::before {
    content: "";
    position: absolute;
    width: 120%;
    height: 4px;
    bottom: 0;
    left: -10%;
    background: linear-gradient(90deg, #ff416c, #ff4b2b, #ff8c00, #ffba08);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.4s ease-in-out;
  }

  &:hover::before {
    transform: scaleX(1);
  }
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 1.2rem;
  opacity: 0.85;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    opacity: 1;
    transform: translateY(-3px);
  }
`;

const HighlightedText = styled.span`
  background: linear-gradient(90deg, #ff416c, #ff4b2b);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
`;
const Footer = styled.div`
  padding: 0.7rem;
  background-color: #414141;
  color: white;
  height: 300px;
`;
const CardBadge = styled.h6`
  min-width: 20px;
  min-height: 20px;
  background-color: #000;
  border-radius: 50%;
  text-align: center;
  margin-left: -10px;
  color: #fff;
`;
const LogoImage = styled.img`
  height: 18px;
  margin-left: 8px;
  @media (min-width: 768px) {
    height: 25px;
    margin-left: 40px;
  }
`;
const LogoImage02 = styled.img`
  height: 25px;
  margin-left: 8px;

  @media (min-width: 768px) {
    height: 30px;
    margin-left: 40px;
  }
`;
const LogoImage03 = styled.img`
  height: 18px;
  margin-left: 2px;
`;
const LogoImageFooter = styled.img`
  height: 18px;
  @media (min-width: 768px) {
    height: 25px;
  }
`;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white; /* Ensure it has a background color */
  z-index: 1000; /* Ensure it appears above other elements */
`;
const StyledAnchor = styled.button`
  padding: 8px 20px;
  background-color: #eb1700;
  color: white;
  text-decoration: none;
  border-radius: 25px;
  text-align: center;
  margin-right: 5px;
  @media (max-width: 336px) {
    padding: 4px 10px;
  }
`;
const StyledAnchor2 = styled.button`
  padding: 8px 20px;
  color: #363332;
  text-align: center;
  background-color: #e6dddc;
  border-radius: 25px;
  margin-right: 10px;
  @media (max-width: 336) {
    padding: 4px 10px;
  }
`;

const AnimatedLink = styled.a`
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease, border-bottom 0.3s ease;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #ddd;
    border-bottom: 1px solid #ddd;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem; /* Smaller font size on smaller screens */
  }
`;

const FooterSection = styled.section`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-bottom: 1rem; /* Add some space below the links on small screens */

  @media (min-width: 768px) {
    /* Keep links in a row on larger screens */
    margin-bottom: 0; /* Remove bottom margin on larger screens */
  }
`;

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const IconsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const DescriptionText = styled.div`
  font-size: 1.1rem;
  opacity: 0.9;
`;

export default FirstPage;
